<!--  -->
<template>
  <div class="main">
    <el-row>
      <el-col :span="23">
        <el-col :span="12">
          <div class="main-text">
            <h1>{{ mainDetail.h1 }}</h1>
            <ul>
              <li v-for="item in mainDetail.lis" :key="item">{{ item }}</li>
            </ul>
            <a :href="mainDetail.type === 'HomePage' ? 'https://www.diboot.com' : 'javascript:;'" :target="mainDetail.type === 'HomePage' ? '_blank' : '_self'">
              <div class="free-use" >
                <span>{{ mainDetail.buttonText }}</span>
                <el-image
                        :src="require('../../assets/icon/triangle.png')"
                        class="triangle"
                ></el-image>
              </div>
            </a>
            <div class="hoverStyle"></div>
          </div>
        </el-col>
        <el-col :span="12" class="mainImg">
          <slot></slot>
          <!--<el-image :src="mainDetail.mainImg" :class="{ marginTop: mainDetail.isMarginTop }"></el-image>-->
        </el-col>
      </el-col>
    </el-row>
    <el-image :src="mainDetail.buttonImg" class="robot"></el-image>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods:{

  },
  props: {
    mainDetail: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style scoped lang="less">
.marginTop {
  margin-top: 50px;
}
.main {
  background-color: #fff;
  height: 625px;
  position: relative;
  .robot {
    position: absolute;
    width: 20%;
    bottom: -18%;
    left: 2%;
    transition: all 0.3s;
    cursor: pointer;
    &:hover {
      transform: translateY(-10px);
    }
  }
  .mainImg {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
  }
  .main-text {
    padding-left: 35%;
    margin-top: 15%;
    position: relative;
    h1 {
      font-size: 36px;
      font-weight: normal;
    }
    li {
      font-size: 16px;
      line-height: 35px;
    }
    .free-use {
      position: absolute;
      top: 115%;
      left: 35%;
      width: 250px;
      height: 60px;
      border-radius: 0 60px 0 60px;
      background: linear-gradient(to right, #55baf7, #6cc87b);
      z-index: 98;
      cursor: pointer;
      transition: all 0.3s;
      display: flex;
      justify-content: center;
      align-items: center;
      .triangle {
        margin-left: 20px;
        width: 8%;
      }
      span {
        color: #fff;
        font-size: 24px;
      }
      &:hover {
        transform: translate(15px, 8px);
      }
    }
    .hoverStyle {
      position: absolute;
      top: 115%;
      left: 35%;
      width: 250px;
      height: 60px;
      border: 1px solid #ebebf0;
      box-sizing: border-box;
      border-radius: 0 60px 0 60px;
    }
  }
}
</style>
